import script from "./EmojiPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&setup=true&lang=js"

import "./EmojiPicker.vue?vue&type=style&index=0&id=c273c294&lang=scss"

const __exports__ = script;

export default __exports__